import { render, staticRenderFns } from "./AboutSeccionResults.vue?vue&type=template&id=0da2be5e&scoped=true"
import script from "./AboutSeccionResults.vue?vue&type=script&lang=js"
export * from "./AboutSeccionResults.vue?vue&type=script&lang=js"
import style0 from "./AboutSeccionResults.vue?vue&type=style&index=0&id=0da2be5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2be5e",
  null
  
)

export default component.exports